<template>
  <div class="accidentRescueList">
    <van-tabs
      v-model="active"
      color="#3399FF"
      title-active-color="#3399FF"
      @change="changeActive"
    >
      <van-tab
        :title="`作业中(${workTotal})`"
        name="1"
      >
        <van-pull-refresh
          v-model="loading"
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="1"
            class="list"
          >
            <accident-rescue-item
              :list="workList"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab
        :title="`已完成(${finishedTotal})`"
        name="2"
      >
        <van-pull-refresh
          v-model="loading"
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="1"
            class="list"
          >
            <accident-rescue-item
              :list="finishedList"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab
        :title="`已取消(${cancelTotal})`"
        name="3"
      >
        <van-pull-refresh
          v-model="loading"
          @refresh="onRefresh"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="1"
            class="list"
          >
            <accident-rescue-item
              :list="cancelList"
            />
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <div class="goAdd">
      <van-button
        type="info"
        class="btn"
        @click="goAdd"
      >新增订单</van-button>
    </div>
  </div>
</template>
<script>
import { orderList } from '@/common/api.js';
import accidentRescueItem from './components/accidentRescue-item.vue';
import { cookieGet, cookieSet } from '@/common/cookie';
export default {
  data() {
    return {
      active: '1',
      workList: [],
      finishedList: [],
      cancelList: [],
      workTotal: 0,
      finishedTotal: 0,
      cancelTotal: 0,
      pageNum: 1,
      loading: false,
      finished: false,
      refreshing: false,
      workStates: ['ADD_INFO_WAIT', 'PAID_WAIT', 'DISPATCH_WAIT', 'PROCESSING'],
      finishedStates: ['AUDIT_WAIT', 'SETTLEMENT_WAIT', 'SETTLEMENT', 'FINISHED', 'AUDIT_RETURN', 'SETTLEMENT_RETURN'],
      cancelStates: ['CANCEL'],
      isLastPage: false
    };
  },
  components: {
    accidentRescueItem
  },
  mounted() {
    this.pageNum = 1;
    this.getOrderList(this.workStates, '1');
    this.getOrderList(this.finishedStates, '2');
    this.getOrderList(this.cancelStates, '3');
  },
  methods: {
    async getOrderList(orderStates, type) {
      try {
        this.loading = true;
        this.finished = true;
        const res = await orderList({
          pageNum: this.pageNum,
          pageSize: 10,
          // channelCompanyCode: cookieGet('channelCompanyCode'),
          productCategoryCodes: ['FL90000002', 'FL90000003', 'FL90000004'],
          orderStates: orderStates
        });
        if (res) {
          if (type === '1') {
            this.workList = [...this.workList, ...res.list];
            this.workTotal = res.total;
            this.finished = this.workList.length >= res.total;
          } else if (type === '2') {
            this.finishedList = [...this.finishedList, ...res.list];
            this.finishedTotal = res.total;
            this.finished = this.finishedList.length >= res.total;
          } else {
            this.cancelList = [...this.cancelList, ...res.list];
            this.cancelTotal = res.total;
            this.finished = this.cancelList.length >= res.total;
          }
          this.loading = false;
        }
      } catch (error) {
        this.finished = true;
        this.loading = false;
        console.log(error);
      }
    },
    changeActive() {
      this.pageNum = 1;
      if (this.active === '1') {
        this.workList = [];
        this.getOrderList(this.workStates, this.active);
      } else if (this.active === '2') {
        this.finishedList = [];
        this.getOrderList(this.finishedStates, this.active);
      } else {
        this.cancelList = [];
        this.getOrderList(this.cancelStates, this.active);
      }
    },
    onLoad() {
      this.pageNum++;
      if (this.active === '1') {
        this.getOrderList(this.workStates, this.active);
      } else if (this.active === '2') {
        this.getOrderList(this.finishedStates, this.active);
      } else {
        this.getOrderList(this.cancelStates, this.active);
      }
    },
    onRefresh() {
      // 清空列表数据
      this.pageNum = 1;
      this.finished = false;
      if (this.active === '1') {
        this.workList = [];
        this.getOrderList(this.workStates, this.active);
      } else if (this.active === '2') {
        this.finishedList = [];
        this.getOrderList(this.finishedStates, this.active);
      } else {
        this.cancelList = [];
        this.getOrderList(this.cancelStates, this.active);
      }
    },
    goAdd() {
      this.$router.push({
        path: '/accidentRescue/edit'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.accidentRescueList{
  font-size: 0.32rem;
  background: #F2F3F5;
  // height: 100vh;
  padding-bottom: 1.2rem;
  .list{
    height: calc(100vh - 2rem);
    overflow-y: scroll;
  }
  .goAdd{
    width: 100vw;
    height: 1.2rem;
    box-shadow: 0 0 0.08rem 0 rgba(0,0,0,0.2);
    background: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn{
      width: 90vw;
      height: 0.8rem;
      border-radius: 0.15rem;
    }
  }
}
</style>
